import { render, staticRenderFns } from "./selectHospital.vue?vue&type=template&id=6551ceae&scoped=true"
import script from "./selectHospital.vue?vue&type=script&lang=js"
export * from "./selectHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551ceae",
  null
  
)

export default component.exports